<section class="page">
  <header class="page-header">
    <div>
      <p>User accountability</p>
      <h2>User imports</h2>
      <span>Search and review user changes recorded by every sync source.</span>
    </div>
    <button type="button" class="refresh" [disabled]="loading" (click)="load()">
      <i class="pi pi-refresh" [class.pi-spin]="loading" aria-hidden="true"></i>
      Refresh
    </button>
  </header>

  <form class="filters" (ngSubmit)="applyFilters()">
    <label>
      Email contains
      <span class="search-input"><i class="pi pi-search" aria-hidden="true"></i><input type="search" name="email" [(ngModel)]="filters.email" placeholder="name@example.com"></span>
    </label>
    <label>
      Source
      <select name="source" [(ngModel)]="filters.source">
        <option value="">All sources</option>
        <option *ngFor="let source of sources" [ngValue]="source">{{ source }}</option>
      </select>
    </label>
    <label>
      Change type
      <select name="changeType" [(ngModel)]="filters.changeType">
        <option value="">All changes</option>
        <option *ngFor="let type of changeTypes" [ngValue]="type">{{ type }}</option>
      </select>
    </label>
    <label>From date<input type="date" name="fromDate" [(ngModel)]="filters.fromDate"></label>
    <label>To date<input type="date" name="toDate" [(ngModel)]="filters.toDate"></label>
    <div class="filter-actions">
      <button type="button" class="secondary" [disabled]="loading" (click)="clearFilters()">Clear</button>
      <button type="submit" class="primary" [disabled]="loading"><i class="pi pi-search" aria-hidden="true"></i> Search</button>
    </div>
  </form>

  <div class="message error" *ngIf="error"><i class="pi pi-exclamation-circle" aria-hidden="true"></i><span>{{ error }}</span></div>

  <div class="table-wrap" *ngIf="data?.items?.length; else state">
    <table>
      <colgroup>
        <col class="email-column"><col class="source-column"><col class="change-column"><col class="roles-column"><col class="created-column">
      </colgroup>
      <thead><tr><th>Email</th><th>Source</th><th>Change</th><th>Roles</th><th>Created</th></tr></thead>
      <tbody>
        <tr *ngFor="let user of data?.items">
          <td><a class="detail-link truncate" [routerLink]="['/user-imports', user.publicId]" [title]="user.email || 'User record'">{{ user.email || 'User record' }}</a></td>
          <td>{{ user.source }}</td>
          <td><span class="change" [class]="'change ' + user.changeType.toLowerCase()">{{ user.changeType }}</span></td>
          <td><span class="truncate" [title]="roleChange(user)">{{ roleChange(user) }}</span></td>
          <td class="created">{{ user.createdAtUtc | date:'medium' }}</td>
        </tr>
      </tbody>
    </table>
  </div>

  <ng-template #state>
    <div class="empty" *ngIf="!error">
      <i [class]="loading ? 'pi pi-spin pi-spinner' : 'pi pi-users'" aria-hidden="true"></i>
      <strong>{{ loading ? 'Loading user imports…' : 'No matching user imports' }}</strong>
      <span *ngIf="!loading">Change or clear the search filters.</span>
    </div>
  </ng-template>

  <app-pagination
    *ngIf="data"
    [page]="paging.page"
    [pageSize]="paging.pageSize"
    [totalCount]="data.totalCount"
    [loading]="loading"
    itemLabel="imports"
    (paginationChange)="changePagination($event)"
  />
</section>
